var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'Closed Registration' }}},[_c('Button',{class:{ 'tall-cta': _vm.tall },attrs:{"type":_vm.type,"href":_vm.loginUrl}},[_vm._v(_vm._s(_vm.title)+"\n      "),(_vm.arrow)?_c('Icon',{attrs:{"type":"arrow-right-c"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56897cd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetStartedButton.vue
// module id = qHOI
// module chunks = 1